import mutations from './certificateHistory.mutations'
import actions from './certificateHistory.actions'
import getters from './certificateHistory.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
